<template>
    <!-- 客户列表 -> 客户详情 -> 产品订购 -->
    <div v-loading="loadAll">
        <!-- PC端-筛选条件 -->
        <div class="shadow-box filter-box" v-if="!$utils.isMobile()">
            <!-- 筛选：产品分类 -->
            <CheckedSelect v-model="form.productId" :options="productList" label="产品分类" @change="fetchData" />
            <!-- 筛选：年份范围 -->
            <div class="filter-line">
                <div class="title-name">年份范围：</div>
                <div class="filter-date-box">
                    <el-date-picker v-model="form.startYear" type="year" placeholder="开始年份" value-format="yyyy" @change="fetchData" />
                    <span>-</span>
                    <el-date-picker v-model="form.endYear" type="year" placeholder="结束年份" value-format="yyyy" @change="fetchData" />
                </div>
            </div>
            <!-- 导出按钮 -->
            <div class="export-box">
                <!-- <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button> -->
            </div>
        </div>
        <!-- 手机端-筛选条件 -->
        <el-drawer title="筛选" :visible.sync="mobileDrawer" direction="btt" size="70%" :wrapperClosable="false" :before-close="closeMobileDrawer"
            custom-class="mobile-filter-drawer">
            <div class="filter-content">
                <!-- 筛选：产品分类 -->
                <MobileSelect v-model="drawerForm.productId" :options="productList" label="产品分类" />
                <!-- 筛选：年份范围 -->
                <div class="filter-line">
                    <div class="title">年份范围</div>
                    <div class="filter-date-box">
                        <el-date-picker v-model="drawerForm.startYear" type="year" placeholder="开始年份" value-format="yyyy" />
                        <span>-</span>
                        <el-date-picker v-model="drawerForm.endYear" type="year" placeholder="结束年份" value-format="yyyy" />
                    </div>
                </div>
            </div>
            <div class="footer-btn">
                <div class="button cancel" @click="closeMobileDrawer">取消</div>
                <div class="button confirm" @click="confirmMobileDrawer">确定</div>
            </div>
        </el-drawer>
        <!-- 数据展示 -->
        <div class="shadow-box" style="margin-top: 20px;" v-if="!$utils.isMobile()">
            <!-- PC端-表格数据 -->
            <el-table :data="tableData">
                <el-table-column prop="year" label="" width="60" align="center" fixed="left"></el-table-column>
                <el-table-column :prop="`month${item}`" :label="getLabel(item)" min-width="70" align="center" v-for="item in 12" :key="item">
                    <template slot-scope="{row}">
                        <div class="order-sign">
                            <i class="el-icon-success" style="color: #37be1d;" v-if="row[`month${item}`] == 1"></i>
                            <i class="el-icon-error" style="color: #e51205;" v-else></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 手机端-列表数据 -->
        <div class="data-list" v-else>
            <div class="year-box shadow-box" v-for="(year, index) in tableData" :key="index">
                <div class="title">{{ year.year }}年</div>
                <ul class="vertical-month">
                    <template v-for="(val, key) in year">
                        <li :key="key" v-if="key.indexOf('month') > -1">
                            <span class="label">{{ getLabel(key) }}</span>
                            <span class="order-sign">
                                <i class="el-icon-success" style="color: #37be1d;" v-if="val == 1"></i>
                                <i class="el-icon-error" style="color: #e51205;" v-else></i>
                            </span>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { findProductOrderTimeList } from '@/api/customer/details.js';

import { mapState } from 'vuex';

export default {
    name: 'productOrder',
    data() {
        return {
            loadAll: false,
            loadExport: false,
            // 筛选条件
            form: {
                productId: null, // 产品id
                startYear: null,
                endYear: null,
            },
            // 移动端筛选条件的抽屉
            mobileDrawer: false,
            drawerForm: {
                productId: null, // 产品id
                startYear: null,
                endYear: null,
            },
            schoolId: null, // 客户id
            // 表格数据
            tableData: [],
        }
    },
    computed: {
        ...mapState(["productList"]),
    },
    created() {
        this.schoolId = this.$route.query.id;
        this.form.productId = this.productList[0].id;
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loadAll = true;
            findProductOrderTimeList({ sid: this.schoolId, ...this.form }).then(res => {
                this.tableData = res.data;
                this.loadAll = false;
            }).catch(err => {
                this.loadAll = false;
                this.tableData = [];
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 获取表头名称
        getLabel(i) {
            let index = String(i);
            if (index.indexOf('month') > -1) {
                index = index.split('month')[1];
            }
            let words = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'];
            return words[index - 1] + '月';
        },
        // 点击导出
        exportData() {
            // this.loadExport = true;
            // downloadLogList({ ...this.logsForm, sId: this.id }).then(res => {
            //     // 处理blob
            //     if (res.data.type === "application/json") {
            //         let blobReader = new Response(res.data).json();
            //         blobReader.then((item) => {
            //             this.$MessageBox.MessageWarning(item.msg);
            //             this.loadExport = false;
            //         });
            //     } else {
            //         // 成功，预览/下载报告
            //         this.$utils.download(res);
            //         this.loadExport = false;
            //     }
            // }).catch(err => {
            //     this.loadExport = false;
            //     this.$MessageBox.MessageWarning(err.data.msg);
            // })
        },
        // 移动端筛选条件抽屉: 开启
        openMobileDrawer() {
            this.mobileDrawer = true;
            this.drawerForm = { ...this.form };
        },
        // 移动端筛选条件抽屉: 关闭
        closeMobileDrawer() {
            this.mobileDrawer = false;
        },
        // 移动端筛选条件抽屉: 确认
        confirmMobileDrawer() {
            this.form = { ...this.drawerForm };
            this.closeMobileDrawer();
            this.fetchData();
        },
    }
}
</script>

<style lang="scss" scoped>
.filter-box {
    position: relative;
    /deep/ .filter-line {
        display: flex;
        &:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .title-name {
            min-width: 6rem;
            padding-top: 5px;
            white-space: nowrap;
        }
        .filter-date-box {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            > .el-input {
                width: 12rem;
                .el-input__inner {
                    width: 12rem;
                    height: 2.2rem;
                    padding-left: 2.5rem;
                    border-color: #ededed;
                    border-radius: 1.6rem;
                    box-shadow: 0 0.06667rem 0.4rem 0.06667rem
                        rgba(0, 0, 0, 0.1);
                }
                .el-input__prefix {
                    left: 0.8rem;
                    .el-input__icon {
                        line-height: 2.2rem;
                    }
                }
            }
        }
    }
    .export-box {
        position: absolute;
        bottom: 20px;
        right: 20px;
        > .el-button {
            border-radius: 0.8rem;
        }
    }
}
.order-sign {
    font-size: 22px;
    vertical-align: text-bottom;
}

// 移动端
.data-list {
    .year-box {
        padding-top: 15px;
        margin-bottom: 20px;
    }
    .title {
        font-size: 18px;
        font-weight: 600;
        text-align: center;
    }
    .vertical-month {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        list-style: none;
        li {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(100% / 3);
            height: 40px;
            border-bottom: 1px solid #f0f0f0;
            .label {
                min-width: 50px;
            }
        }
    }
}
</style>